import React, { useState, useEffect } from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { url , header } from "../Constent/Constant";
import { Modal, message } from 'antd';

const containerStyle = {
  width: '100%',
  height: '400px'
};

function Map() {
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [MapLat, setMapLat] = useState('')
  const [MapLong, setMapLong] = useState('')

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyBm-xt-zBBtvE_AreqkHODWIsNvkrsU1Qw"
  })
  const [MapData, setMapData] = useState('')

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  console.log(map)

  // const onUnmount = React.useCallback(function callback(map) {
  //   setMap(null)
  // }, [])

  useEffect(() => {
    DataUpdate()
  }, [])

  const DataUpdate = () => {
    fetch(`${url}/page/getalllocations`)
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if(data.doc.length !== 0 ){
          setMapData(data.doc)
        }
      })
  }

  const center = {
    lat: MapData && MapData !== null ? MapData[0].lat : 80.2566,
    lng: MapData && MapData !== null ? MapData[0].lng : 26.1670
  }

  const handleCancel = () => {
    setTextModalVisible(false);
  };


  const TextHandle = () => {
    setTextModalVisible(false);
  };

  const ShowTextModal = () => {
    setTextModalVisible(true);
  };

  const onDelete = (id) => {
    fetch(`${url}/page/deletelocation`,{
      method:'Delete',
      body:JSON.stringify({
        id:id
      }),
      headers:header
    })
    .then(res => res.json())
    .then(data => {
      console.log(data)
      if(data.message === 'Success'){
        DataUpdate()
      }
    })
  }

  const OnAddMarkers = () => {
    if ( MapLat === '' || MapLong === ''){
      message.error('Fill All Fields')
    }else{
      fetch(`${url}/page/addlocation`,{
        method:'Post',
        body:JSON.stringify({
          lng:MapLong,
          lat:MapLat
        }),
        headers:header
      })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if(data.message === 'Success'){
          DataUpdate()
        }
      })
    }
  }

  return isLoaded ? (
    <div className='Map-container'>
      <i onClick={ShowTextModal} className="far fa-edit Edit-btn"></i>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
      // onUnmount={onUnmount}
      >
        {
          MapData ? MapData.map(data => (
            <Marker position={{
              lat: data.lat,
              lng: data.lng
            }} />
          )) : <></>
        }
      </GoogleMap>


      {/* Map list Modal */}
      <Modal width={600} style={{ top: '10%' }} title='Map Markers List' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Ok" >
        <div className='Maps-list-div'>
          <div className='List-Head'>
            <h3>Longitude</h3>
            <h3>Latitude</h3>
            <h3>Action</h3>
          </div>
          <div className='Map-list'>
            {
              MapData && MapData.map(data => (
                <div className='List-item'>
                  <h3> {data.lng} </h3>
                  <h3> {data.lat} </h3>
                  <div className='Left-div'>
                    <button onClick={() => onDelete(data._id)} className='Delte-btn'>Delete</button>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
        <div className='Map-Input'>
        <input type='number' value={MapLat} onChange={e => setMapLat(e.target.value)} className='Input' placeholder='Add Latitude...' />
        <input type='number' value={MapLong} onChange={e => setMapLong(e.target.value)} className='Input' placeholder='Add Longitude...' />
        <button onClick={OnAddMarkers}>Add</button>
        </div>
      </Modal>

    </div>
  ) : <></>
}

export default React.memo(Map)